const Constants = {
  colors: {
    bug: "#729f3f",
    dragon: "#f16e57",
    electric: "#eed535",
    fairy: "#fdb9e9",
    fighting: "#d56723",
    fire: "#fd7d24",
    flying: "#3dc7ef",
    ghost: "#7b62a3",
    ground: "#ab9842",
    grass: "#9bcc50",
    ice: "#51c4e7",
    normal: "#a4acaf",
    poison: "#b97fc9",
    psychic: "#f366b9",
    rock: "#a38c21",
    steel: "#9eb7b8",
    water: "#4592c4",
  },
};

export default Constants;
